import React from 'react';

const Error044 = () => {

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <div className="flex surface-section">
                        <div className="w-12 sm:w-6 px-4 py-8 md:px-6 lg:px-8">
                            <div className="border-left-2 border-pink-500">
                                <span className="bg-white text-pink-500 font-bold text-2xl inline-block px-3">404</span>
                            </div>
                            <div className="mt-6 mb-5 font-bold text-6xl text-900">Page Not Found</div>
                            <p className="text-700 text-3xl mt-0 mb-6">Sorry, we couldn't find the page.</p>
                            <div>
                                <button className="p-button p-component p-button-text mr-2">
                                    <span className="p-button-icon p-c p-button-icon-left pi pi-arrow-left"></span>
                                    <span className="p-button-label p-c">Go Back</span><span className="p-ink"></span>
                                </button>
                                <button className="p-button p-component">
                                    <span className="p-button-icon p-c p-button-icon-left pi pi-home"></span>
                                    <span className="p-button-label p-c">Go to Dashboard</span>
                                    <span className="p-ink"></span>
                                </button>
                            </div>
                        </div>
                        <div className="w-6 hidden sm:block"></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(Error044, comparisonFn);







